
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"4","fill":"#FCF0D2"}}),_c('path',{attrs:{"d":"M26.099 11.092v9.08a2.093 2.093 0 01-2.092 2.092h-.642c.108-.252.173-.534.173-.836v-9.081a2.093 2.093 0 00-2.092-2.092H16.21A2.095 2.095 0 0118.129 9h5.878c1.154 0 2.092.938 2.092 2.092z","fill":"#FFB30B"}}),_c('path',{attrs:{"d":"M24.648 11.828v9.08c0 .296-.065.577-.173.837A2.1 2.1 0 0122.557 23H7.994a2.093 2.093 0 01-2.092-2.091v-6.304c0-1.155.938-2.092 2.092-2.092h4.746c.837 0 1.587-.498 1.911-1.255.022-.043.037-.087.05-.13a2.094 2.094 0 011.97-1.385h5.886c1.154 0 2.091.938 2.091 2.092v-.007z","fill":"#FFD664"}}),_c('path',{attrs:{"d":"M19.802 9.736l-7.653 13.257H8.002A2.093 2.093 0 015.91 20.9v-6.304c0-1.154.938-2.091 2.092-2.091h4.746a2.078 2.078 0 001.962-1.385 2.094 2.094 0 011.969-1.385h3.123z","fill":"#FFCD50"}})])
          )
        }
      }
    